<template>
  <div class="valor-declaration">
    <h3>{{ $t(getTextType('procedures.steps.fourth.declaration.title'))}}</h3>
    <p v-if="demandStore.dv_docs.dv">
      <span class="valor-declaration--text">
        {{ $t('procedures.steps.fourth.declaration.receivedDeclaration')}}
      </span>
      (<el-link
        target="_blank"
        type="primary"
        class="valor-declaration--download-link"
        :underline="false"
        :href="demandStore.dv_docs.dv">
        {{ $t('procedures.steps.fourth.declaration.declarationLabel') }}
      </el-link>)
    </p>
    <p v-if="isValorDeclarationSent">
      {{ $t('procedures.steps.fourth.declaration.sentDeclaration') }}
    </p>
    <div>
      <p v-if="demandStore.dv_docs.dv">
      {{ $t('procedures.steps.fourth.declaration.modificationDeclaration') }}
      </p>
      <p v-else>
        {{ $t('procedures.steps.fourth.declaration.texteDeclaration.first') }}
        {{ $t('procedures.steps.fourth.declaration.texteDeclaration.second') }}
      </p>
      <p>
        <el-link
          class="valor-declaration--link"
          target="_blank"
          type="primary"
          :underline="false"
          :href="demandStore.dv_docs.dv_model">
          {{ $t('procedures.steps.fourth.declaration.declarationExample') }}
        </el-link>
      </p>
    </div>
    <div class="valor-declaration--file-upload">
      <input-upload
        :id="'file-upload'"
        class="valor-declaration--file-upload__input"
        text="Charger un fichier (PDF)"
        :files.sync="files"
      />
      <el-button
        :disabled="!files.length || declarationLoading"
        type="success"
        :loading="declarationLoading"
        class="valor-declaration--file-upload__btn"
        @click="uploadFile">
        {{ $t('base.send') }}
      </el-button>
    </div>
    <!-- <router-link class="valor-declaration--redirect"
      :to="{ name: 'declaration' }">
      <el-link
        class="button-link valor-declaration--redirect--link"
        :underline="false">
        {{ $t('procedures.steps.fourth.declaration.declarationRedirection') }}
      </el-link>
    </router-link> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputUpload from '@/utils/components/InputUpload.vue';
import pathText from '@/utils/helpers/pathText';

export default {
  name: 'valorDeclaration',
  components: {
    InputUpload,
  },
  props: {
    isValorDeclarationSent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    ...mapGetters({
      declarationLoading: 'demandStore/declarationLoading',
      demandStore: 'demandStore/demand',
    }),
  },
  methods: {
    ...mapActions({
      postValorDeclaration: 'demandStore/postValorDeclaration',
    }),
    getTextType(text) {
      return pathText.getTextType(text);
    },
    uploadFile() {
      const formData = new FormData();
      formData.append('file', this.files[0]);
      this.postValorDeclaration(formData).then(() => {
        this.$emit('update:isValorDeclarationSent', true);
        this.files = [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
.valor-declaration {
  margin: 20px 0;
  &--text {
    color: $--color-tertiary;
    font-weight: bold;
  }
  &--download-link {
    font-weight: bold;
    font-size: 16px;
  }
  &--link {
    font-size: 16px;
  }
  &--redirect {
    text-decoration: none;
    &--link {
      margin-top: 10px;
    }
  }
  &--file-upload {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    &__input {
      display: flex;
    }
    &__btn {
      line-height: 20px;
      font-weight: bold;
      font-size: 14px;
      padding: 7px 12px;
    }
  }
}
</style>
